var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherMessages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 9.45258C10.0227 9.45258 10.0406 9.43468 10.0406 9.41258V9.41199C10.0406 9.38958 10.0224 9.3714 10 9.3714C9.97759 9.3714 9.95942 9.38958 9.95942 9.41199C9.95942 9.43441 9.97759 9.45258 10 9.45258H10.0006",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88283 9.45258C7.90492 9.45258 7.92283 9.43468 7.92283 9.41258V9.41199C7.92283 9.38958 7.90466 9.3714 7.88224 9.3714C7.85982 9.3714 7.84165 9.38958 7.84165 9.41199C7.84165 9.43441 7.85982 9.45258 7.88224 9.45258H7.88283",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0595 9.45258C12.0816 9.45258 12.0995 9.43468 12.0995 9.41258V9.41199C12.0995 9.38958 12.0814 9.3714 12.0589 9.3714C12.0365 9.3714 12.0183 9.38958 12.0183 9.41199C12.0183 9.43441 12.0365 9.45258 12.0589 9.45258H12.0595",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14163 5H11.1979C11.8406 5 12.4487 5.14798 12.99 5.41173C14.3543 6.0765 15.2944 7.47671 15.2944 9.0965V9.13902C15.2944 10.2255 14.8628 11.2674 14.0946 12.0357C13.3264 12.8039 12.2844 13.2355 11.1979 13.2355H10.596C10.5917 13.2355 10.5883 13.239 10.5883 13.2432V14.5741C10.5883 14.7247 10.5088 14.8641 10.3791 14.9407C10.2495 15.0173 10.0891 15.0198 9.95713 14.9473L7.00386 13.323C5.5863 12.5434 4.70557 11.0539 4.70557 9.43607C4.70556 8.25955 5.17293 7.13122 6.00485 6.29929C6.83678 5.46737 7.96511 5 9.14163 5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherMessages);
export default ForwardRef;